import React from 'react';
import  GitaDharaClass3  from 'views/GitaDharaClass3';

const AccountGeneralPage = () => {
  return <GitaDharaClass3 />;
};

export default AccountGeneralPage;